import React, {useState, useEffect} from 'react'
import styled from 'styled-components'
import Toptop from './toptop'
import Link from 'next/link'
import {list} from './data'


const HeadWrapper = styled.div`
    max-width: 1200px;
    margin: 0 auto;
`

const Nav = styled.div`
  background: rgba(0,0,0,0.2);
  position: fixed;
  top:0;
  left:0;
  right:0;
  width:  100vw;
  .showMenuMob {
      visibility: visible;
      opacity: 1;
  }
`

const Hamburger = styled.div`
    position: fixed;
    background: rgba(0,0,0,0.3);
    top:0em;
    left:0em;
    width: 100%;
    font-size: 2.3em;
    cursor:pointer;
    display: none;
    transition: all .3s ease-in-out;
    @media (max-width: 640px) {
       display: flex;
       justify-content: flex-end;
        
        div {
        padding-right: .4em;
        }       
    }
    ${props => props.showMenuMob && 'color:white;'};
`

const StyledSubMenu = styled.div`
    opacity: 0; 
    visibility: hidden; 
    
    background: rgba(0,0,0,.6);
    border-radius: 4px;
    padding: 1em;
    position: absolute;
    top: 4.5em;
    left:-1em;
    width: 10em;

  @media (max-width: 640px) {
  position: static;
  .submenu{
   display:none;
  }
  .showSubMob {
    // opacity: 1; 
    
    display:block;
    //visibility: visible; 
  }
  }
`


const MenuItem = styled.div`
  line-height: 1.8em;
  position: relative;
  cursor: pointer;
  .submenu{
      transition: all .3s ease-in-out;

  }
  
  @media (min-width: 641px) {
    padding-top: 3em;
    padding-bottom: 1em;
      &:hover {
          .submenu {  
              visibility: visible;
              opacity: 1;
          }
      }
  }
  
  @media (max-width: 640px) {
    
    a {color: white;}
    
    .submenu {  
        display: none;
    }
    .showSubMob {    
      visibility: visible;
      opacity: 1;
      display: block;
    }

  }
  
`
const SubMenuItem = styled.div`
  a{color:white;}
  transition: all .3s ease;

`

const StyledMenu = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: space-evenly;
  transition: all .3s ease-in-out;
    @media (max-width: 640px) {
     //display: none;
     opacity: 0; 
     visibility: hidden; 
     background: rgba(0,0,0,0.97);
     position: fixed;
     width: 100%;
     height:100%;
     top: 0em;
     left:0;
     justify-content: flex-start;
     flex-direction: column;
      color: white;
      a {color: white}
    }
`

const Arrow = styled.div`
  display: none;
  @media (max-width: 640px) {
     display: block;
     position: absolute;
     top:0;
     right:6em;
  }
`

const MenuRow = styled.div`
  width: 70%;
  display: flex;
  justify-content: space-between;
`


const SubMenu = props => {

    const [showSubMob, setShowSubMob] = useState(false)

    const handleClick = () => {
        let temp = !showSubMob
        setShowSubMob(temp)
        console.log('ss')
    }

    const buildSub = props.sub.map(subitem => (
        <SubMenuItem><Link href={props.label+subitem.label}><a>{subitem.value}</a></Link></SubMenuItem>
    ))
    return (
        <div>
            <Arrow onClick={handleClick}>↓</Arrow>
            <StyledSubMenu className={`submenu ${showSubMob && 'showSubMob'}`}>
                {buildSub}
            </StyledSubMenu>
        </div>
    )
}




const Menu = props => {

    const menulist = list.map(item => (
            <MenuItem>
                <MenuRow><Link href={item.label}><a>{item.value}</a></Link></MenuRow>
                {item.sub && <SubMenu sub={item.sub} label={item.label}/>}
            </MenuItem>
        ))
    return (
        <StyledMenu className={props.showMenuMob && 'showMenuMob'}>
            {menulist}
            <Toptop showMenuMob={props.showMenuMob}/>
        </StyledMenu>
    )
}




export default props => {
    const [showMenuMob, setShowMenuMob] = useState(false)


    useEffect(() => {

    }, [props])

    const handleClick = () => {
        setShowMenuMob(!showMenuMob)
    }
    const handleClose = () => {
        setShowMenuMob(false)
    }

    return (
        <Nav>
            <HeadWrapper>
                <Menu showMenuMob={showMenuMob} closeMenu={handleClose}/>
                <Hamburger onClick={handleClick} showMenuMob={showMenuMob}><div>=</div></Hamburger>
            </HeadWrapper>
        </Nav>
    )
}
